<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='btns.qry'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-search" @click='buttonClk("search")' :title='$t("TS.ts_search")'/></div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'TsMenuButton',
  data() {
    return {
      btns: {
        setTime: true,
        qry: true
      }
    };
  },
  methods: {
    buttonClk(args) {
      console.log(args);
      this.$emit('methodEnum', args);
    }
  }
};
</script>

<style scoped>

</style>
